import Vuelidate from 'vuelidate';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.use(Vuelidate);
});